module.exports = ":host {\n  display: block;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/dense/dense.component.css
// module id = ./src/app/examples/dense/dense.component.css
// module chunks = main